import { DELETE } from "../API"
export const removeOwnMessageReactionApi = (conversationId, messageId, reactionId, onSuccess, onError) => {
    DELETE(`/api/v1/chat/conversations/${conversationId}/messages/${messageId}/reactions/${reactionId}`, onSuccess, onError)
}